import { render, staticRenderFns } from "./WorkerFormFooter.vue?vue&type=template&id=c9d04f96&"
import script from "./WorkerFormFooter.vue?vue&type=script&lang=js&"
export * from "./WorkerFormFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports